import React from 'react'
import { Link } from 'react-router-dom'


const SOCIAL_LINKS = [
  { name: "Facebook", href: "https://facebook.com/finrelinsure", icon: "fab fa-facebook-f" },
  { name: "Twitter", href: "https://twitter.com/finrelinsure", icon: "fab fa-twitter" },
  { name: "LinkedIn", href: "https://linkedin.com/company/finrelinsure", icon: "fab fa-linkedin-in" },
  { name: "Instagram", href: "https://instagram.com/finrelinsure", icon: "fab fa-instagram" },
];

function Footer() {
  return (
    <>
        <footer className="footer-two footer-two--home-1">
            <div className="footer-two__top">
                <div className="container">
                    <div
                        className="footer-two__top__inner"
                        style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "24px", rowGap: "20px", borderBottom: "none" }}
                    >
                        <p className="footer-two__copyright__text" style={{ margin: 0 }}>
                            Copyright © <span className="dynamic-year" /> FinReliable Technology IMF, All rights Reserved
                        </p>

                        <ul
                            className="list-unstyled footer-one__widget__menu"
                            style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "24px", margin: 0 }}
                        >
                            <li><Link to="/delivery-policy">Delivery Policy</Link></li>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/refund-policy">Refund Policy</Link></li>
                            <li><Link to="/terms">Terms and Conditions</Link></li>
                            <li><Link to="/disclaimer">Website Disclaimer</Link></li>
                        </ul>

                        <ul className="list-unstyled footer-two__widget__social">
                            {SOCIAL_LINKS.map((social) => (
                                <li key={social.name}>
                                    <a href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.name}>
                                        <i className={social.icon} />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

        </footer>
    </>
  )
}

export default Footer